import { useEffect } from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';

import { useStore } from '../../hooks';
import ValuationPaymentComplete from './components/valuationPaymentComplete';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardKnoxIframe: {
      border: 0,
      height: '1060px',
      width: '100%',
      [theme.breakpoints.down(975)]: {
        height: '2100px',
      },
    },
  })
);

const PaymentStep = observer(() => {
  const { valuationPaymentStore } = useStore();
  const { paymentStatus, cardKnoxURL, cardHolderName } = valuationPaymentStore;
  const iframeSrc = cardKnoxURL && cardHolderName
    ? `${cardKnoxURL}&xName=${encodeURIComponent(cardHolderName.trim())}`
    : cardKnoxURL;
  const classes = useStyles();

  return (
    <>
      <Box style={{ maxWidth: 840, margin: 'auto' }}>
        <Box mb={2}>
          <Typography variant="h4">Payment</Typography>
        </Box>
      </Box>

      <Box mt={3} style={{ maxWidth: 840, margin: 'auto' }}>
        {!paymentStatus ? (
          <Box mt={3}>
            {iframeSrc ? (
              <iframe
                title="CardKnox Payment Form"
                className={classes.cardKnoxIframe}
                src={iframeSrc}
                scrolling="no"
              />
            ) : (
              <Box textAlign="center" py={4}>
                <Typography variant="body1">
                  {/* TODO: Add endpoint later - CardKnox URL will be loaded from backend */}
                  Loading payment form...
                </Typography>
              </Box>
            )}
          </Box>
        ) : (
          <Box mt={1}>
            <ValuationPaymentComplete />
          </Box>
        )}
      </Box>
    </>
  );
});

export default PaymentStep;
